import React, { useMemo } from 'react';
import '@op/assets/scss/pages/community/influencer.scss';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { Layout } from 'tea-component';
import { connect, useIntl } from 'umi';
import BubbleCommon, {
  communityInfluencerTitleText,
} from '@/pages/opinion/components/BubbleCommon';
import CommonFilter from '../components/CommonFilter';
import KeyMetrics from './KeyMetrics';
import InfluencerProfile from './InfluencerProfile';
import PublicationPerformance from './PublicationPerformance';
import influencerBrandOverview from '@op/operationLog/pages/influencerBrandOverview';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { PAGE_NAME } from '@op/constants/page';

const { Content } = Layout;

const BrandOverview = ({
  gameInfo,
  hidePageHeader,
  hideTips,
  filterInstanceId,
  enableSourcePageLog = true,
}: any) => {
  const { formatMessage } = useIntl();
  const filterGameInfo = useMemo(
    () => ({
      ...gameInfo,
      filterInstanceId,
    }),
    [gameInfo, filterInstanceId],
  );

  useInitBuriedPointInfo({
    buriedPoint: influencerBrandOverview,
    triggerPagePoint: enableSourcePageLog,
  });
  return (
    <Content className="dbo-page dbo-influencer">
      <ContentBody
        isInfluencer
        hidePageHeader={hidePageHeader}
        hideTips={hideTips}
        pageName={PAGE_NAME.BRAND_OVERVIEW}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.BRAND_OVERVIEW })}
            operation={
              <span style={{ fontSize: 12, color: '#707070' }}>
                <BubbleCommon
                  iconStyle={{ marginLeft: 5 }}
                  tipsMap={communityInfluencerTitleText}
                >
                  {formatMessage({ id: 'Data Update' })}
                </BubbleCommon>
              </span>
            }
          />
        }
      >
        <CommonFilter gameInfo={filterGameInfo}>
          {({ params, mediaType }) => {
            return (
              <div>
                <KeyMetrics
                  mediaType={mediaType}
                  filter={params}
                  gameInfo={filterGameInfo}
                ></KeyMetrics>
                <InfluencerProfile
                  filter={params}
                  mediaType={mediaType}
                  gameInfo={filterGameInfo}
                ></InfluencerProfile>
                <PublicationPerformance
                  filter={params}
                  mediaType={mediaType}
                  gameInfo={filterGameInfo}
                ></PublicationPerformance>
              </div>
            );
          }}
        </CommonFilter>
      </ContentBody>
    </Content>
  );
};

export default connect((state: { opinionCommon: any; }) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(BrandOverview);
